export enum YmGoalHelixbook {
  ItemAddToCart = 'helixbookItemAddToCart',
}
